import React from "react";
import { Box, Typography } from "@material-ui/core";

// Icons
import {
  BathIcon,
  BedIcon,
  StraightenIcon,
  UnitSizeIcon,
} from "../../../../../../assets/icons";

export const UnitModelsTableHeaderData = (palette, styles) => [
  {
    id: 1,
    formFieldId: 1,
    minWidth: 230,
    headerName: "Unit modal",
    field: "propertyUnitModelName",
    displayPath: "propertyUnitModelName",
    fieldKey: "propertyUnitModelName",
    formFieldTitle: "propertyUnitModelName",
    searchKey: "propertyUnitModelName",
    isHiddenFilter: false,
    sortable: true,
    filterable: true,
    fieldType: "text",
    isDefaultFilterColumn: true,
    disableColumnMenu: true,
    renderCell: (item) => {
      return <div>{item?.row?.propertyUnitModelName || 'N/A'}</div>;
    },
  },
  {
    id: 2,
    formFieldId: 2,
    minWidth: 230,
    headerName: "Number of units",
    field: "unitsNo",
    displayPath: "unitsNo",
    fieldKey: "unitsNo",
    formFieldTitle: "unitsNo",
    searchKey: "unitsNo",
    isHiddenFilter: false,
    sortable: true,
    filterable: true,
    fieldType: "text",
    isDefaultFilterColumn: true,
    disableColumnMenu: true,
    renderCell: (item) => {
        return <div>{item?.row?.unitsNo || 'N/A'}</div>;
      },
  },
  {
    id: 3,
    formFieldId: 3,
    minWidth: 230,
    headerName: "Unit Type",
    field: "unitTypeName",
    displayPath: "unitTypeName",
    fieldKey: "unitTypeName",
    formFieldTitle: "unitTypeName",
    searchKey: "unitTypeName",
    isHiddenFilter: true,
    sortable: true,
    filterable: true,
    fieldType: "text",
    isDefaultFilterColumn: true,
    disableColumnMenu: true,
    renderCell: (item) => {
        return <div>{item?.row?.unitTypeName || 'N/A'}</div>;
      },
  },
  {
    id: 4,
    formFieldId: 4,
    minWidth: 444.33331298828125,
    headerName: "Unit details",
    field: "area",
    displayPath: "area",
    fieldKey: "area",
    formFieldTitle: "area",
    searchKey: "area",
    isHiddenFilter: true,
    sortable: true,
    filterable: true,
    fieldType: "text",
    isDefaultFilterColumn: true,
    disableColumnMenu: true,
    renderCell: (item) => {
      return (
        <Box className={styles.containerDetailsUnit}>
          <Box className={styles.containerTypeDetails}>
            <UnitSizeIcon
              width="20"
              height="20"
              fill={palette.foreground.quinary}
            />
            <Typography>{item?.row?.area || 'N/A'}</Typography>
          </Box>
          <Box className={styles.containerTypeDetails}>
            <BedIcon width={20} height={20} fill={palette.foreground.quinary} />
            <Typography>{item?.row?.bathroomNo}</Typography>
          </Box>
          <Box className={styles.containerTypeDetails}>
            <BathIcon
              width={20}
              height={20}
              fill={palette.foreground.quinary}
            />
            <Typography>{item?.row?.bedroomNo}</Typography>
          </Box>
          <Box className={styles.containerTypeDetails}>
            <StraightenIcon
              width={20}
              height={20}
              fill={palette.foreground.quinary}
            />
            <Typography>{item?.row?.bedroomNo || 'N/A'}</Typography>
          </Box>
        </Box>
      );
    },
  },
  {
    id: 5,
    formFieldId: 5,
    minWidth: 444.33331298828125,
    headerName: "Selling price range",
    field: "sellingPriceFrom",
    displayPath: "sellingPriceFrom",
    fieldKey: "sellingPriceFrom",
    formFieldTitle: "sellingPriceFrom",
    searchKey: "sellingPriceFrom",
    isHiddenFilter: true,
    sortable: true,
    filterable: true,
    fieldType: "text",
    isDefaultFilterColumn: true,
    disableColumnMenu: true,
    renderCell: (item) => {
      return (
        <Box className={styles.containerFromTO}>
          <Typography className={styles.typePriceTitle}>ADE</Typography>
          <Typography className={styles.fromToTitle}>
            {`${item?.row?.sellingPriceFrom} - ${item?.row?.sellingPriceTo}`}
          </Typography>
        </Box>
      );
    },
  },
  {
    id: 6,
    formFieldId: 6,
    minWidth: 444.33331298828125,
    headerName: "Rent price range",
    field: "rentPerYearFrom",
    displayPath: "rentPerYearFrom",
    fieldKey: "rentPerYearFrom",
    formFieldTitle: "rentPerYearFrom",
    searchKey: "rentPerYearFrom",
    isHiddenFilter: true,
    sortable: true,
    filterable: true,
    fieldType: "text",
    isDefaultFilterColumn: true,
    disableColumnMenu: true,
    renderCell: (item) => {
      return (
        <Box className={styles.containerFromTO}>
          <Typography className={styles.typePriceTitle}>ADE</Typography>
          <Typography className={styles.fromToTitle}>
            {`${item?.row?.rentPerYearFrom} - ${item?.row?.rentPerYearTo}`}
          </Typography>
        </Box>
      );
    },
  },
];
